import Vue from "vue";
import Vuex from "vuex";
import firebase from "firebase/app";
import "firebase/auth";
// eslint-disable-next-line no-unused-vars
import data from "../services/data";
import api from "../services/api";
import VuexPersistence from "vuex-persist";

Vue.use(Vuex);

// eslint-disable-next-line no-undef,no-unused-vars
const vuexLocal = new VuexPersistence({
  storage: window.localStorage
});

export const store = new Vuex.Store({
  plugins: [vuexLocal.plugin],
  state: {
    isCompany: true,
    email: "",
    uid: "",
    token: "",
    status: "",
    verify: false,
    companyData: {},
    companyContact: "",

    // student or stuff
    ldap: false,
    ldap_token: "",
    ldap_status: "",
    ldap_expire: true,
    studentId: "",
    company_all: [],
    all_jobs: [],
    all_jobs_count: 0,
    kmuttId: ""
  },
  mutations: {
    auth_success(state, currentUser) {
      state.status = "success";
      state.uid = currentUser.uid;
      state.email = currentUser.email;
      state.verify = currentUser.verify;
      localStorage.setItem("status", state.status);

      state.ldap = false;
      state.ldap_expire = true;
      state.ldap_status = "";
      state.ldap_token = "";
      state.kmuttId = "";
    },
    auth_error(state) {
      state.status = "error";
      localStorage.setItem("status", state.status);
    },
    email_verify(state, verify) {
      state.verify = verify;
    },
    email_sent(state) {
      state.status = "email sent";
      localStorage.setItem("status", state.status);
    },
    logout(state) {
      state.status = "";
      state.uid = "";
      state.email = "";
      state.token = "";
      state.verify = false;
      state.companyData = {};
      state.emailSent = false,

      state.ldap = false;
      state.ldap_expire = true;
      state.ldap_status = "";
      state.ldap_token = "";
      state.kmuttId = "";
      localStorage.setItem("status", state.status);
    },
    kmutt_logout(state) {
      state.status = "";
      state.uid = "";
      state.email = "";
      state.token = "";
      state.verify = false;
      state.companyData = {};

      state.ldap = false;
      state.ldap_expire = true;
      state.ldap_status = "";
      state.ldap_token = "";
      state.kmuttId = "";
    },
    kmutt_loginsuccess(state, response) {
      state.status = "";
      state.uid = "";
      state.email = "";
      state.token = "";
      state.verify = false;
      state.companyData = {};

      state.ldap_token = response.token;
      state.kmuttId = response.username;
      state.ldap = true;
      state.ldap_status = response.type;
      state.ldap_expire = false;
    },
    get_companyData_success(state, company) {
      state.companyData = company.data;
      state.companyContact = company.data.contact_person.firstName;
      state.token = company.token;
    },
    update_companyData(state, company) {
      for (let companyKeyword in state.companyData) {
        if (company[companyKeyword]) {
          state.companyData[companyKeyword] = company[companyKeyword]
        }
      }
    },
    CLEAR_STATE_ALL(state) {
      state.isCompany = true
      state.email = ""
      state.uid = ""
      state.token = ""
      state.status = ""
      state.verify = false
      state.companyData = {}

      // student or stuff
      state.ldap = false
      state.ldap_token = ""
      state.ldap_status = ""
      state.ldap_expire = true
      state.studentId = ""
      state.company_all = []
      state.all_jobs = []
      state.all_jobs_count = 0
      state.kmuttId = ""
    },

    GET_ALL_JOBS_SUCCESS(state, data) {
      state.all_jobs = data
    },
    GET_JOBS_COUNT_SUCCESS(state, data) {
      state.all_jobs_count = data
    },
    GET_ALL_JOBS_FAILED() {
      console.log("GET_ALL_JOBS_FAILED")
    },
    GET_All_COMPANY_SUCCESS(state, companies) {
      state.company_all = companies
    },
    GET_All_COMPANY_FAILED() {
      console.log("GET_All_COMPANY_FAILED")
    },
    CHANGE_COMPANY_STATUS_SUCCESS() {
      console.log("CHANGE_COMPANY_STATUS_SUCCESS")
    },
    CHANGE_COMPANY_STATUS_FAILED() {
      console.log("CHANGE_COMPANY_STATUS_FAILED")
    },
  },
  actions: {
    async login({commit}, user) {
      await firebase
        .auth()
        .signInWithEmailAndPassword(user.username, user.password)
        .then(() => {
          commit("auth_success", {
            uid: firebase.auth().currentUser.uid,
            verify: firebase.auth().currentUser.emailVerified,
            email: user.username
          });
        })
        .catch(err => {
          alert(err.message);
          commit("auth_error");
        });
    },
    async logout({commit}) {
      await firebase
        .auth()
        .signOut()
        .then(() => {
        })
        .catch(err => {
          alert(err.message);
        });
      commit("logout");
    },
    async companyRegister({commit}, user) {
      await firebase
        .auth()
        .createUserWithEmailAndPassword(user.email, user.password)
        // eslint-disable-next-line no-unused-vars
        .then(res => {
          // firebase
          //   .auth()
          //   .currentUser.sendEmailVerification()
          //   .then(() => {
          //     commit("email_sent");
          //     // alert("Sent Email Verification");
          //   })
          //   .catch(err => {
          //     console.log(`Send Email Verification Error: ${err}`);
          //   });
          commit("auth_success", {
            uid: firebase.auth().currentUser.uid,
            verify: firebase.auth().currentUser.emailVerified,
            email: user.email
          });
        })
        .catch(err => {
          console.log(`Create User Error: ${err.message}`);
        });
    },
    emailverify({commit}) {
      if (firebase.auth().currentUser.emailVerified) {
        commit("email_verified");
      } else {
        firebase
          .auth()
          .currentUser.sendEmailVerification()
          .then(() => {
            commit("email_sent");
            // alert("Sent Email Verification");
          })
          .catch(err => {
            console.log(`Email Verification Error: ${err}`);
          });
        commit("email_verify", firebase.auth().currentUser.emailVerified);
      }
    },
    resetpass({commit}, user) {
      firebase
        .auth()
        .sendPasswordResetEmail(user.username)
        .then(() => {
          alert("Sent Email Verification");
          commit("email_sent");
        })
        .catch(error => {
          console.log(`Reset Password By Email Error: ${error}`);
        });
    },
    async kmuttLogin({commit}, user) {
      await api
        .kmuttLogin(user)
        .then(res => {
          let userDetail = {
            username: user.username,
            token: res.data.data,
            type: res.data.type
          };
          if (res.data.isSuccess) {
            commit("kmutt_loginsuccess", userDetail);
          } else {
            alert(res.data.errorMsg);
          }
        })
        .catch(err => {
          console.log(403, err.data);
        });
    },
    kmuttLogout({commit}) {
      commit("kmutt_logout")
    },
    getCompanyData({commit}) {
      if (firebase.auth().currentUser) {
        let uid = firebase.auth().currentUser.uid;
        firebase
          .auth()
          .currentUser.getIdToken(false)
          .then(idToken => {
            api
              .getCompanyDetial(idToken, {
                id: uid
              })
              .then(res => {
                let companyData = {
                  data: res.data.data[0],
                  isSuccess: res.data.isSuccess,
                  token: idToken
                };
                if (companyData.isSuccess === true) {
                  commit("get_companyData_success", companyData);
                } else {
                  console.log("Company, No data");
                }
              })
              .catch(err => {
                console.log(err);
              });
          });
      } //else {
        // console.log("No login");
      // }
    },
    updateCompanyDataState({commit}, company) {
      commit("update_companyData", company)
    },
    getAllJobs({commit}) {
      api.getAllJobs()
        .then(async res => {
          if (res.data.isSuccess) {
            const companies = res.data.data;
            let jobsCount = 0
            companies.forEach(company => {
              jobsCount += company.jobs.length
            })

            commit("GET_ALL_JOBS_SUCCESS", companies)
            commit("GET_JOBS_COUNT_SUCCESS", jobsCount)
          } else {
            commit("GET_ALL_JOBS_FAILED")
          }
        }).catch(() => {
        commit("GET_ALL_JOBS_FAILED")
      })
    },
    async getCompanyDetailForStaff({commit}) {
      await api.getCompanyDetailForStaff(this.state.ldap_token)
        .then(async (res) => {
          if (res.data.isSuccess) {
            const allCompany = await res.data.data
            await commit("GET_All_COMPANY_SUCCESS", allCompany)
            return allCompany
          } else {
            commit("GET_All_COMPANY_FAILED")
          }
        })
    },
    async changeStatusCompany({commit}, company) {
      await api.changeStatusCompany(this.state.ldap_token, company)
        .then(() => {
          commit("CHANGE_COMPANY_STATUS_SUCCESS")
        })
        .catch(() => {
          commit("CHANGE_COMPANY_STATUS_FAILED")
        })
    },
    async checkToken({commit}) {
      await api.checkToken(this.state.ldap_token)
        .then((res) => {
          if (res.data.isSuccess === false) {
            commit('CLEAR_STATE_ALL')
            this.$router.push({path: "/"})
          }
        })
        .catch(() => {
          commit('CLEAR_STATE_ALL')
          if (this.$router) {
            this.$router.push({path: "/"})
          }
        })
    }
  },
  getters: {
    // company
    getUserId: state => state.uid,
    getEmail: state => state.email,
    getStatus: state => state.status,
    getCompanyDetail: state => state.companyData,
    getContact: state => state.companyContact,
    getCompanyToken: state => state.token,

    // student of staff
    getStudentId: state => state.studentId,
    getStudentToken: state => state.ldap_token,
    getKmuttToken: state => state.ldap_token,
    getKmuttStatus: state => state.ldap_status,
    getKmuttId: state => state.kmuttId,
  }
});
